module.exports = __webpack_public_path__ + "static/media/cover.995e97bb.png";